import { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { datadogRum } from '@datadog/browser-rum'

interface DatadogUserClient {
  setUser(user: { id: string; email: string; name: string }): void
  clearUser(): void
}

interface DatadogUserIdentityProps {
  rumClient?: DatadogUserClient
}

function getNonEmptyString(value: unknown) {
  if (typeof value !== 'string') {
    return undefined
  }

  const trimmedValue = value.trim()
  return trimmedValue || undefined
}

export function DatadogUserIdentity({
  rumClient = datadogRum,
}: DatadogUserIdentityProps) {
  const { authState } = useOktaAuth()
  const isAuthenticated = authState?.isAuthenticated
  const email = getNonEmptyString(authState?.idToken?.claims.email)
  const name = getNonEmptyString(authState?.idToken?.claims.name)

  useEffect(() => {
    if (isAuthenticated === undefined) {
      return
    }

    if (!isAuthenticated || !email) {
      rumClient.clearUser()
      return
    }

    rumClient.setUser({
      id: email,
      email,
      name: name ?? email,
    })
  }, [email, isAuthenticated, name, rumClient])

  return null
}
